// Angular
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
// RxJS
import { map } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// Auth reducers and selectors
import { AppState } from '../state/root/';
import { selectUser } from '../state/user/user.selectors';

export const authGuardFn: CanActivateFn =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const router: Router = inject(Router);
        const store: Store<AppState> = inject(Store<AppState>);

        return store.pipe(
            select(selectUser),
            map(e => {
                // NOTE: Tried different appraoches couldn't find one that was clean / "working"
                // Comenting out below so we don't have the flashing login page on slow pc / internet connections
                // Session expired page should catch this and route users to login page
                // LifeCyle: Store initalizes -> User == null -> ROOT_EFFECTS_INIT fires ->  fetch user called -> flash login page -> fetch user success -> routed to correct page

                // if (e == null) {
                //     return router.parseUrl('/login')
                // }

                const url = state.url;
                sessionStorage.setItem(`lastUrl_${e?.id}`, url);
                return true;
            })
        )
    };
